import axios, { AxiosResponse } from 'axios';
import { ICommonAspxApi } from './apiAspxNotification';
import { IGroupedApi, createGroupedApi, ISportsBettingSessionApiForDesktop, SportsBettingApiResult, AppType, ICommonAppSettings, IDateTimeFormater, ILoggingService, IConnectionMonitorService, sportsBettingSessionBaseApi } from 'eTip--common';
import { IRecaptchaProvider } from 'src/modules/eTipCommon/recaptcha/recaptchaProvider';


export function connectSportsBettingGroupedSessionApi(param: any): IGroupedApi<ISportsBettingSessionApiForDesktop> {
    return createGroupedApi(_token => {
        return param;
    });
}

export function createSportsBettingSessionApi(params: { baseUrl: string; settings: ICommonAppSettings; aspxApi: ICommonAspxApi, dateTimeFormatter: IDateTimeFormater }, loggingService: ILoggingService, connectionMonitorService: IConnectionMonitorService, recaptchaProvider: IRecaptchaProvider): ISportsBettingSessionApiForDesktop {

    const tokenExpired = () => {
        params.aspxApi.sessionTokenExpired();
    };
    const tokenOk = () => {
        params.aspxApi.sessionTokenOk();
    };

    const baseApi = sportsBettingSessionBaseApi({ baseUrl: params.baseUrl, settings: params.settings, dateTimeFormater: params.dateTimeFormatter, tokenOk: tokenOk, tokenExpired: tokenExpired }, loggingService, connectionMonitorService);

    const baseUrl = params.baseUrl + '/WebServices/ApiSession/SportsBettingSessionService.svc';
    const languageId = params.settings.language.id;
    let token: string;
    let tokenVersion: string;

    return {
        getInitDataAsync: async (appType: AppType) => {
            const recaptchaResponse = await recaptchaProvider.ScoreAction('GetInitData');

            return new Promise<any>((f, r) => {
                axios
                    .post(
                        baseUrl + '/GetLiveInitData',
                        {
                            Version: params.settings.tokenVersion,
                            LanguageID: params.settings.language.id,
                            AppType: appType,
                            CanGetRightBanner: ((__IsMTS__ && (appType === AppType.PartialPrematch || appType === AppType.FullLive) || __IsMTSTipos__) ? true : undefined),  //TODOHLEGACYREM
                            RecaptchaResponse: recaptchaResponse
                        },
                        { withCredentials: true }
                    )
                    .then((response: AxiosResponse<any>) => {
                        //console.log("Logovani response getInitDataAsync");
                        //console.log(response.data);

                        if (response.data.Result == SportsBettingApiResult.Success) {
                            params.aspxApi.settingsLoaded(response);
                            token = response.data.Token;
                            tokenVersion = params.settings.tokenVersion;
                            baseApi.setToken(token);
                            f(response);
                            return;
                        }
                        r({error: new Error('Unexpected result ' + response.data.Result), isRecaptchaInvalid: response.data.IsRecaptchaInvalid});
                    })
                    .catch(error => {
                        r(error);
                    });
            });
        },

        playerSignInAsync: (params: any) => {
            return new Promise<any>((f, r) => {
                axios
                    .post(baseUrl + '/PlayerSignIn', {
                        Version: tokenVersion,
                        LanguageID: languageId,
                        LoginName: params.login,
                        Password: params.password,
                        Token: token,
                        // UrlHash: "49359e4f9b9f364f081a53cdd54d5d3e0bbbaca3393c40a0e4c7cd8e50440911",
                        UseLongPolling: false
                    },
                        { withCredentials: true })
                    .then((response: any) => {
                        f(response.data);
                        console.log('login response :', response);
                    })
                    .catch(error => {
                        console.log('login error :', error);
                        r(error);
                    });
            });
        },

        tokenOk: tokenOk,
        tokenExpired: tokenExpired,

        getServerTimeAsyncForMts: baseApi.getServerTimeAsyncForMts
    };
}
